<!--
 @description Decorative cookie icon button intended as a persistent trigger
 to reopen the cookie consent banner. Renders only a cookie icon with no
 interactive behaviour of its own — the parent must attach a click handler.
 Pair with CookieBanner to give users a way to revisit their consent choices.

 @example
 <CookieButton @click="showBanner = true" />
-->
<template>
  <span class="no-style-button cookie-button">
    <i class="fi fi-rr-cookie-alt"> </i>
  </span>
</template>

<style scoped lang="scss">
.cookie-button {
  position: fixed;
  bottom: 90px;
  left: 20px;
  height: 1.5rem;
  width: 1.5rem;
  padding: $half-spacing;
  background-color: var(--white);
  border-radius: 50%;
  z-index: 10;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: var(--black-4);

    i {
      color: var(--white);
    }
  }

  i {
    font-size: 1.5rem;
    color: var(--black-4);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-49%, -42%);
    transition: all 0.2s ease-in-out;
  }
}
</style>
